// components/FilterButtons.js
import React from 'react'
import { API_URL } from './../constants'
import { useContext } from '../Context'
import axios from 'axios'

const FilterButtons = () => {
    const { globalState, setGlobalState } = useContext()
    const { activeFilter, selectedFile, limit } = globalState

    const handleButtonClick = async (buttonType) => {

        setGlobalState((prevState) => ({ ...prevState, activeFilter: buttonType }))

        if (selectedFile && buttonType !== 'both') {
            console.log('selected file already so reloading the matches')
            setGlobalState((prevState) => ({
                ...prevState,
                isMatchLoading: true
            }))

            const formData = new FormData()
            formData.append('image', selectedFile, selectedFile.name)
            formData.append('limit', limit)
            formData.append('product_type', activeFilter)

            const response = await axios.post(`${API_URL}/check-image-against-library`, formData)

            setGlobalState((prevState) => ({
                ...prevState,
                match: response.data.closestMatch,
                topMatches: response.data.topMatches,
                timeTaken: response.data.timeTaken,
                librarySize: response.data.librarySize,
                isMatchLoading: false
            }))
        }

    }

    return (
        <>
            <p>Select your application - Fabric or Wall Covering</p>
            <div className="button-group">
                <button
                    className={`filter-button ${activeFilter === 'wall_covering' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('wall_covering')}
                >
                    Wall Covering
                </button>
                <button
                    className={`filter-button ${activeFilter === 'fabric' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('fabric')}
                >
                    Fabric
                </button>
                {/* <button
                className={`filter-button ${activeFilter === 'both' ? 'active' : ''}`}
                onClick={() => handleButtonClick('both')}
            >
                Both
            </button> */}
            </div>
        </>
    )
}

export default FilterButtons
